export class StatusEvent {
    constructor({ status }) {
        this.name = 'status';
        this.status = status;
    }
    get data() {
        return {
            status: this.status,
        };
    }
}
